import { SCREENING_STATUS } from "@/constants";

export default {
  result: null,
  details: null,
  query: null,
  status: SCREENING_STATUS.NOT_ASKED,
  error: null
};
